module.exports = __webpack_public_path__ + "media/images/edion/building-c91eeac183c816a2adf438cabc1e1be0.png";